import type { FilterTypes } from "../../table-filter/filter-types/types";

import { birthdayStrategy } from "./birthday";
import { booleanStrategy } from "./boolean";
import { dateStrategy } from "./date";
import { defaultStrategy } from "./default";
import { dollarStrategy } from "./dollar";
import { idStrategy } from "./id";
import { multiselectStrategy } from "./multiselect";
import { numberStrategy } from "./number";
import { numberRangeStrategy } from "./number-range";
import { phoneNumberStrategy } from "./phone-number";
import { providerStrategy } from "./provider";
import { sortStrategy } from "./sort";
import { textStrategy } from "./text";
import type { FilterStrategy } from "./types";

const STRATEGIES: Record<FilterTypes, FilterStrategy> = {
  text: textStrategy,
  number: numberStrategy,
  select: defaultStrategy,
  // Toggle rows are searched by label in FilterList, not by option values.
  toggle: defaultStrategy,
  boolean: booleanStrategy,
  multiselect: multiselectStrategy,
  date: dateStrategy,
  "date-select": dateStrategy,
  dollar: dollarStrategy,
  sort: sortStrategy,
  phoneNumber: phoneNumberStrategy,
  id: idStrategy,
  provider: providerStrategy,
  location: multiselectStrategy,
  "number-range": numberRangeStrategy,
  birthday: birthdayStrategy,
  // Segmentation-only; not surfaced in table-filter search.
  relativeDate: defaultStrategy,
  // Segmentation-only compound filters; not surfaced in table-filter search.
  serviceDateRange: defaultStrategy,
  serviceNumberRange: defaultStrategy,
};

export function getStrategy(type: FilterTypes): FilterStrategy {
  return STRATEGIES[type] ?? defaultStrategy;
}

export type { FilterStrategy, SearchContext } from "./types";
